import { useQuery } from '@tanstack/react-query';
import ApprovalsService from 'src/services/approvals.service';

export const usePendingsQuery = (params: {
  page: number;
  limit: number;
  sortBy: string;
  sortDirection: string;
  search: string;
  companyId: string;
  startDate: string;
  endDate: string;
  status: string;
  employmentType: string;
  changeType: string;
  employeeCompany: string;
  EmploymentStatus: string;
  selectedTab: string;
}) => {
  const results = useQuery(['approvals/pendings'], async () => {
    if (!params.companyId) return { items: [], meta: { totalItems: 0 } };
    const result = await ApprovalsService.getPendingApprovals({
      page: params.page,
      limit: params.limit,
      sortBy: params.sortBy,
      sortDirection: params.sortDirection,
      search: params.search,
      companyId: params.companyId,
      startDate: params.startDate,
      endDate: params.endDate,
      status: params.status,
      employeeStatus: params.EmploymentStatus,
      change: params.changeType,
      employeeCompany: params.employeeCompany,
      employmentStatus: params.employmentType,
      selectedTab: params.selectedTab,
    });
    return result;
  });
  return results;
};
